import { Fragment } from 'react'
import { Link } from '@inertiajs/react'
import { Group, Anchor, Text } from '@mantine/core'

// Visible breadcrumb trail. crumbs: [{ name, path? }]; the last item (no path)
// is the current page. Mirrored 1:1 by the BreadcrumbList JSON-LD.
export default function Breadcrumb({ crumbs }) {
  return (
    <Group gap={6} wrap="wrap" mb="xs">
      {crumbs.map((c, i) => (
        <Fragment key={i}>
          {i > 0 && (
            <Text c="dimmed" size="sm">
              ›
            </Text>
          )}
          {c.path ? (
            <Anchor component={Link} href={c.path} size="sm">
              {c.name}
            </Anchor>
          ) : (
            <Text size="sm" c="dimmed">
              {c.name}
            </Text>
          )}
        </Fragment>
      ))}
    </Group>
  )
}
